// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { Headline } from "#/components/headline/Headline";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import InlineSVG from "../../../components/inline_svg/InlineSVG";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
    ImageAspectRatio,
    InlineSVG,
  },
})
export class BranchenAnchorModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }
}
